import { css, CSSResult } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'
import { csFormControl } from 'elements/_shared/form.style.js'
import { csColorAction, csColorBorder, csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { cseFormField } from 'elements/form-field/form-field.style.js'


export const cseUpload = {
  backgroundColor: css`var(--cse-upload-background-color, ${csFormControl.backgroundColor})`,
  borderColor: css`var(--cse-upload-border-color, ${csColorBorder.medium})`,
  borderRadius: css`var(--cse-upload-border-radius, ${csBorder.radiusMinimal})`,
  borderWidth: css`var(--cse-upload-border-width, ${csFormControl.borderWidth})`,
  color: css`var(--cse-upload-color, ${csFormControl.color})`,
  gap: css`var(--cse-upload-gap, ${csSpacing.spacing04})`,
  iconColor: css`var(--cse-upload-icon-color, ${csColorFunctional.info})`,
  iconColorHover: css`var(--cse-upload-icon-color-hover, ${csColorAction.linkPrimaryHover})`,
  mobilePaddingX: css`var(--cse-upload-mobile-padding-x, ${csSpacing.spacing08})`,
  mobilePaddingY: css`var(--cse-upload-mobile-padding-y, ${csSpacing.spacing08})`,
  paddingX: css`var(--cse-upload-padding-x, ${csSpacing.spacing08})`,
  paddingY: css`var(--cse-upload-padding-y, ${csSpacing.spacing10})`,
}

export const style: CSSResult = css`
  @keyframes heartbeat {
    0% {
      transform: scale(1);
    }
    25% {
      transform: scale(1.1);
    }
    50% {
      transform: scale(1);
    }
    75% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  :host {
    display: block;
  }

  .cse-upload {
    background-color: ${cseUpload.backgroundColor};
    border-color: ${cseUpload.borderColor};
    border-radius: ${cseUpload.borderRadius};
    border-style: dashed;
    border-width: ${cseUpload.borderWidth};
    color: ${cseUpload.color};
    cursor: pointer;
    padding-block: ${cseUpload.paddingY};
    padding-inline:  ${cseUpload.paddingX};
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${cseUpload.gap};
  }

  :host([mobile-screen]) .cse-upload {
    padding-block: ${cseUpload.mobilePaddingY};
    padding-inline: ${cseUpload.mobilePaddingX};
  }

  .cse-upload.disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }

  .icon {
    --cse-icon-color: ${cseUpload.iconColor};
  }

  .dragging .icon {
    --cse-icon-color: ${cseUpload.iconColorHover};
    animation: heartbeat 1.5s ease-in-out infinite;
  }

  :host([mobile-screen]) .icon {
    margin-right: ${csSpacing.spacing04};
  }

  .text {
    display: flex;
    align-items: center;
    gap: ${csSpacing.spacing02};
  }

  :host([mobile-screen]) .text {
    flex-direction: row;
    align-items: center;
    gap: ${csSpacing.spacing02};
  }

  input {
    display: none;
  }

  .status {
    --cse-text-color: ${cseFormField.helpTextColor};
  }

  .error {
    --cse-text-color: ${cseFormField.invalidTextColor};
  }

  :host([mobile-screen]) .status,
  :host([mobile-screen]) .error {
    width: 100%;
  }
`
